import { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import api from "../api";

// Modale generica
export function Modal({ title, children, onClose, wide }) {
  // Chiude SOLO se il clic inizia E finisce sullo sfondo (evita la chiusura
  // quando si seleziona testo trascinando dentro un campo e si rilascia fuori).
  const downOnOverlay = useRef(false);
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return createPortal(
    <div className="modal-overlay"
      onMouseDown={(e) => { downOnOverlay.current = e.target === e.currentTarget; }}
      onClick={(e) => { if (e.target === e.currentTarget && downOnOverlay.current) onClose(); }}>
      <div className="modal" style={wide ? { maxWidth: 760, width: "92vw" } : undefined}>
        <button className="modal-close" onClick={onClose} aria-label="Chiudi" data-testid="modal-close">✕</button>
        <h3>{title}</h3>
        {children}
      </div>
    </div>,
    document.body
  );
}

// Hook per caricare le etichette
export function useTags() {
  const [tags, setTags] = useState([]);
  const reload = () => api.get("/tags").then((r) => setTags(r.data)).catch(() => {});
  useEffect(() => { reload(); }, []);
  return { tags, reload };
}

// Mostra le etichette come chip colorati
export function TagChips({ tagIds, tags }) {
  if (!tagIds || tagIds.length === 0) return <span className="muted">—</span>;
  return (
    <>
      {tagIds.map((id) => {
        const t = tags.find((x) => x.id === id);
        if (!t) return null;
        return (
          <span key={id} className="chip" style={{ background: t.color }}>
            {t.name}
          </span>
        );
      })}
    </>
  );
}

// Selettore multiplo di etichette (checkbox)
export function TagPicker({ tags, selected, onChange }) {
  const toggle = (id) => {
    if (selected.includes(id)) onChange(selected.filter((x) => x !== id));
    else onChange([...selected, id]);
  };
  if (tags.length === 0) return <p className="muted">Nessuna etichetta. Creale nella sezione Etichette.</p>;
  return (
    <div className="tag-filter">
      {tags.map((t) => (
        <label key={t.id} className="chip" style={{ background: selected.includes(t.id) ? t.color : "#94a3b8", cursor: "pointer", opacity: selected.includes(t.id) ? 1 : 0.55 }}>
          <input type="checkbox" checked={selected.includes(t.id)} onChange={() => toggle(t.id)} style={{ width: "auto", margin: 0 }} />
          {t.name}
        </label>
      ))}
    </div>
  );
}

export const KINDS = [
  { value: "cliente", label: "Cliente", color: "#16a34a" },
  { value: "cliente_cessato", label: "Cliente cessato", color: "#dc2626" },
  { value: "lead", label: "Lead", color: "#f59e0b" },
  { value: "partner", label: "Partner", color: "#3b82f6" },
  { value: "studio", label: "Studio", color: "#a855f7" },
  { value: "altro", label: "Altro", color: "#64748b" },
];

export function KindBadge({ kind }) {
  const k = KINDS.find((x) => x.value === kind) || KINDS[KINDS.length - 1];
  return <span className="badge" style={{ background: k.color + "22", color: k.color, border: `1px solid ${k.color}55` }}>{k.label}</span>;
}
